module.exports = __webpack_public_path__ + "img/deviceCloud1.3744aac1.jpg";